'use client';

import * as React from 'react';
import { GridChartsPanelDataBody } from "./GridChartsPanelDataBody.mjs";
import { GridChartsPanelDataHeader } from "./GridChartsPanelDataHeader.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GridChartsPanelData() {
  const [searchValue, setSearchValue] = React.useState('');
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(GridChartsPanelDataHeader, {
      searchValue: searchValue,
      onSearchValueChange: setSearchValue
    }), /*#__PURE__*/_jsx(GridChartsPanelDataBody, {
      searchValue: searchValue
    })]
  });
}
export { GridChartsPanelData };